import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { JarwisService } from "src/app/Services/jarwis.service";

@Component({
  selector: "app-email-verification",
  templateUrl: "./email-verification.component.html",
  styleUrls: ["./email-verification.component.scss"],
})
export class EmailVerificationComponent implements OnInit {
  public formValues = {
    email: null,
    token: null,
  };

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private jarwis: JarwisService,
    private router: Router
  ) {

    this.route.queryParams.subscribe((params) => {
      this.formValues.token = params["token"];
    });

    this.route.queryParams.subscribe((params) => {
      this.formValues.email = params["email"];
    });

  }

  ngOnInit() {
    this.jarwis.emailVerification(this.formValues).subscribe(
      (data) => this.handleResponse(data),
      (error) => this.handleError(error)
    );
  }

  handleResponse(data) {
    if (data["message"] == "Success") {
      this.toastr.success("Email verified Successfully");
    }
    if (data["message"] == "Error") {
      this.toastr.error(data["reason"]);
    }
    this.router.navigateByUrl("/login");
  }

  handleError(error) {
    this.toastr.error("Email Already Verified or Incorrect token");
  }
}
